<template>
  <div class="py-2 px-4">
    <v-row class="px-3">
      <v-col>
        <p class="text-h5 mb-6"> Sélection de niveau : </p>

        <ContentPanel title="Niveau" :items="levels" :loading="loading" @updateContent="updateProductLevel" />

        <p class="text-h5 mt-6 mb-0"> Sélection de produits : </p>

        <div class="d-flex justify-space-between">
          <v-checkbox
            v-model="isLimitedProduct"
            label="Test Eval"
            hide-details
            color="third"
          />
          <v-checkbox
            v-model="isOnDemandProduct"
            label="On demand"
            color="third"
            hide-details
          />
        </div>
        <v-text-field
          v-model="search"
          color="third"
          flat
          hide-details
          clearable
          append-icon="mdi-magnify"
          class="pt-3"
          label="Recherche"
        />
      </v-col>
      <v-col cols="1" />
      <v-col class="align-content-end">
        <v-combobox
          :items="offersType"
          label="Type de produit"
          multiple
          color="third"
          chips
          hide-details
          :menu-props="{ 'z-index': '1500 !important'}"
          item-value="value"
          item-text="label"
          @input="selectOfferType"
        />
        <!-- <ContentPanel title="Type de produit" :items="offersType" @updateContent="updateSelectedOfferType" /> -->
      </v-col>
    </v-row>
    <v-row>
      <ContentTable class="full-width" :headers="headers" :items="products" :items-selected="filterSelected" @updateSelected="updateSelected" />
    </v-row>
    <v-row justify="center" class="ma-4">
      <v-btn color="third" class="white--text" height="32" :disabled="!selectedAssignProducts.length" @click="nextStep()">
        Etape suivante
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { ref, computed, inject, onBeforeMount } from '@vue/composition-api';
import ContentPanel from './ContentPanel.vue';
import ContentTable from './ContentTable.vue';
import store from '@/store';
import { getLevels } from '@/helpers/request';
import { getReferences, getReferenceLabel } from '@/helpers/utils';

const localReferences = require('@/configs/references.json');

export default {
  components: { ContentPanel, ContentTable },
  setup (props, context) {
    const headers = inject('productHeaders');
    const loading = ref(false);
    const product = ref(null);
    const search = ref('');
    const isLimitedProduct = ref(false);
    const isOnDemandProduct = ref(false);
    const selectedAssignProducts = inject('selectedAssignProducts');
    const alphaProducts = computed(() => store.state.products);
    const selectedOfferType = ref([]);
    const levels = ref([]);

    onBeforeMount(async () => {
      loading.value = true;
      const { data } = await getLevels();
      levels.value = data.filter(item => !!item).map(i => ({ label: i.name, value: i.uuid }));
      loading.value = false;
    });

    const updateProductLevel = tableItem => {
      const levelsUuids = tableItem.map(item => item.value);

      const productsFromLevel = (alphaProducts.value || []).filter(p => (p.level || []).some(level => levelsUuids.includes(level.uuid)));

      (productsFromLevel || []).map(prod => {
        const index = selectedAssignProducts.value.findIndex(sp => sp.uuid === prod.uuid);
        if (index !== -1) {
          return;
        }
        const offerLabel = prod.dynamo_offers.map(o => getReferenceLabel('offerTypes', o.offerType)).join(', ');
        selectedAssignProducts.value.push({ ...prod, testEval: prod.isLimitedProduct ? 'Oui' : 'Non', onDemand: prod.on_demand ? 'Oui' : 'Non', offersLabel: offerLabel });
      });
    };

    const filterProduct = p => {
      if (isLimitedProduct.value && !p.isLimitedProduct) {
        return false;
      }

      if (isOnDemandProduct.value && !p.on_demand) {
        return false;
      }

      if (!p.name.toLowerCase().includes((search.value || '').toLowerCase())) {
        return false;
      }

      const productHaveSelectedOffer = p.dynamo_offers.some(o => selectedOfferType.value.includes(o.offerType));

      if (selectedOfferType.value.length && !productHaveSelectedOffer) {
        return false;
      }

      return true;
    };

    const filterSelected = computed(() => selectedAssignProducts.value.filter(p => filterProduct(p)));

    const offersType = computed(() => (getReferences('offerTypes')));

    const products = computed(() => {
      const productsToReturn = alphaProducts.value.map(p => {
        const offerLabel = (p.dynamo_offers.map(o => getReferenceLabel('offerTypes', o.offerType)).join(', ') || '');
        return { ...p, testEval: p.isLimitedProduct ? 'Oui' : 'Non', onDemand: p.on_demand ? 'Oui' : 'Non', offersLabel: offerLabel };
      });

      return productsToReturn.filter(p => !selectedAssignProducts.value.some(prod => prod.uuid === p.uuid)).filter(p => filterProduct(p));
    });

    const updateSelected = items => {
      const { selected, deselected, action } = items;

      switch (action) {
        case 'select':
          // all deselected to selected
          deselected.map(item => {
            selectedAssignProducts.value.push(item);
          });
          break;
        case 'deselect':
          // all selected to deselected
          selected.map(item => {
            const indexSelectedAssign = selectedAssignProducts.value.findIndex(c => c.uuid === item.uuid);

            if (indexSelectedAssign !== -1) {
              selectedAssignProducts.value.splice(indexSelectedAssign, 1);
            }
          });
          break;
        default:
          break;
      }
    };

    const selectOfferType = items => {
      selectedOfferType.value = items.map(item => item.value);
    };

    const nextStep = () => {
      context.emit('next-step', localReferences.productStepper.CONFIRMATION);
    };

    return { selectOfferType, selectedOfferType, offersType, filterSelected, isOnDemandProduct, isLimitedProduct, headers, product, search, products, updateSelected, selectedAssignProducts, nextStep, updateProductLevel, levels, loading };
  }
};
</script>
